var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#6B7280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5H11.914L10.207 3.293C10.1143 3.2 10.0041 3.12624 9.88273 3.07596C9.7614 3.02568 9.63134 2.99986 9.5 3H4.5C3.397 3 2.5 3.897 2.5 5V19C2.5 20.103 3.397 21 4.5 21H20.5C21.603 21 22.5 20.103 22.5 19V7C22.5 5.897 21.603 5 20.5 5ZM4.5 19V7H20.5L20.502 19H4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.84c709c3be385f7890117a02b847f2af.svg";
export { ForwardRef as ReactComponent };